import LogUtil from "@/betby/utils/LogUtil";
import type { CurrencyMode } from "@/betby/store/navStore";
import type { UnityMessageRuntime } from "@/betby/infrastructure/host/unityMessageRuntime";

export const UNITY_RECEIVE_MESSAGE_TYPES = {
  WALLET_DATA: "WalletData",
  MONEY_TYPE: "MoneyType",
  SPORT_NAVIGATE: "sport_navigate",
} as const;

type MoneyTypePayload = {
  currencyType: CurrencyMode;
  moneyTypeValue: 0 | 1;
};

function parseMoneyTypePayload(data: unknown): MoneyTypePayload | null {
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  const moneyTypeValue = Number(data[0]);
  if (moneyTypeValue !== 0 && moneyTypeValue !== 1) {
    return null;
  }

  return {
    currencyType: moneyTypeValue === 1 ? "gc" : "sc",
    moneyTypeValue,
  };
}

export async function handleUnityReceiveMessage(params: {
  type: string;
  data: unknown;
  runtime: UnityMessageRuntime | null;
}): Promise<boolean> {
  const { data, runtime, type } = params;

  switch (type) {
    case UNITY_RECEIVE_MESSAGE_TYPES.WALLET_DATA:
      LogUtil.info(
        "[UnityReceiveMessageService] 收到 WalletData，开始刷新余额",
      );

      if (!runtime?.refreshWallet) {
        LogUtil.warn(
          "[UnityReceiveMessageService] WalletData runtime 未注册，忽略刷新请求",
        );
        return true;
      }

      await runtime.refreshWallet();
      return true;

    case UNITY_RECEIVE_MESSAGE_TYPES.MONEY_TYPE: {
      const payload = parseMoneyTypePayload(data);
      if (!payload) {
        LogUtil.warn(
          "[UnityReceiveMessageService] MoneyType 数据非法，忽略:",
          data,
        );
        return true;
      }

      LogUtil.info(
        `[UnityReceiveMessageService] 收到 MoneyType: ${payload.moneyTypeValue} -> ${payload.currencyType}`,
      );

      if (!runtime?.syncMoneyType) {
        LogUtil.warn(
          "[UnityReceiveMessageService] MoneyType runtime 未注册，忽略同步请求",
        );
        return true;
      }

      await runtime.syncMoneyType(payload.currencyType);
      return true;
    }

    case UNITY_RECEIVE_MESSAGE_TYPES.SPORT_NAVIGATE: {
      const targetUrl = typeof data === "string" ? data : null;
      if (!targetUrl) {
        LogUtil.warn(
          "[UnityReceiveMessageService] sport_navigate 数据非法，忽略:",
          data,
        );
        return true;
      }

      LogUtil.info(
        "[UnityReceiveMessageService] 收到 sport_navigate:",
        targetUrl,
      );

      if (!runtime?.navigate) {
        LogUtil.warn(
          "[UnityReceiveMessageService] navigate runtime 未注册，忽略导航请求",
        );
        return true;
      }

      runtime.navigate(targetUrl);
      return true;
    }

    default:
      return false;
  }
}
